import { Box, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/system';

const genericStyles = {
  fontFamily: 'Schibsted Grotesk',
  fontSize: '16px',
  fontWeight: 400,
  color: '#181818',
};

const useTableStyles = makeStyles((theme: Theme) => ({
  tableWrapper: {
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    marginTop: '10px',
    borderSpacing: 0,
    borderCollapse: 'separate',
    border: '1px solid #D6D6D6',
    overflow: 'hidden',
    '& .MuiTableHead-root': {
      backgroundColor: '#F6F6F6',
    },
    '& td': {
      borderBottom: '0px solid transparent',
      paddingBottom: '8px',
      paddingTop: '8px',
      [theme.breakpoints.down(8000)]: {
        '& > div': {
          maxWidth: '284px',
          wordWrap: 'break-word',
        },
      },
    },
    '& th': {
      ...genericStyles,
      color: '#878787',
      fontWeight: 500,
      fontSize: '14px',
      paddingBottom: '8px',
      paddingTop: '8px',
    },
    '& a': {
      ...genericStyles,
      color: '#F83B3B',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 500,
    },
  },
}));

const RemoveWrapper = styled('a')(() => ({
  ...genericStyles,
  color: '#F83B3B',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 500,
}));

const TitleWrapper = styled(Box)(() => ({
  ...genericStyles,
}));

export { TitleWrapper, RemoveWrapper, useTableStyles };
